import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import PropTypes from 'prop-types';

const propTypes = {
    enableDesktopAppIcons: PropTypes.bool,  // Display separate app store buttons on non-mobile devices
    label: PropTypes.string,                // Text label for link or button
    logPrefix: PropTypes.string,            // Beginning portion of advance analytics log
    type: PropTypes.string                  // Link or Button Type Style
};

const defaultProps = {
    enableDesktopAppIcons: false,
    label: "Download the App",
    logPrefix: "MBHWeb.UI.DownloadAppBtn",
    type: "button",
}

class DownloadAppBtn extends Component {
    constructor(props) {
        super(props);
        this.IPHONE_APP_URL = `${props.ssoBaseUrl}app_download/iphone`;
        this.GOOGLE_PLAY_URL = `${props.ssoBaseUrl}app_download/android`;
        this.downloadiOSMobileApp = this.downloadiOSMobileApp.bind(this);
        this.downloadAndroidMobileApp = this.downloadAndroidMobileApp.bind(this);
        this.downloadMobileApp = this.downloadMobileApp.bind(this);
        this.isMobile = Tools.isMobile();
        this.android = Tools.isAndroid();
        this.ios = Tools.isIos();
    }

    componentDidMount() {
        logUI('MBHWeb.UI.DownloadAppBtn.ComponentDidMount', new Date(), Tools.getURLPath());
    }

    downloadiOSMobileApp() {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP 
        if (typeof window !== 'undefined')
            window.location.href = this.IPHONE_APP_URL;
        logUI(`${this.props.logPrefix}.iTunes.Redirect`, new Date(), '/iTunesDownload');
    }

    downloadAndroidMobileApp() {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING PLAY STORE TO DOWNLOAD APP 
        if (typeof window !== 'undefined')
            window.location.href = this.GOOGLE_PLAY_URL;
        logUI(`${this.props.logPrefix}.GooglePlay.Redirect`, new Date(), '/GooglePlayDownload');
    }

    downloadMobileApp() {
        if (this.ios) {
            logUI(`${this.props.logPrefix}.DownloadApp.iTunes.Clicked`, new Date(), Tools.getURLPath());
            this.downloadiOSMobileApp();
        } else {
            logUI(`${this.props.logPrefix}.DownloadApp.GooglePlay.Clicked`, new Date(), Tools.getURLPath());
            this.downloadAndroidMobileApp();
        }
    }

    render() {

        const { enableDesktopAppIcons, label, logPrefix, type } = this.props;
        const buttonLabel = label;
        const buttonClassName = type && type === "button" ? "btn btn-primary" : "";
        const buttonURL = this.ios ? "https://itunes.apple.com/us/app/mybswhealth/id1000856979?mt=8" :
                          this.android ? "https://play.google.com/store/apps/details?id=com.baylorscottandwhite.healthsource&hl=en_US" : "";


        return (
            <React.Fragment>
                {!this.isMobile && enableDesktopAppIcons
                    ? <div className="download-app-container app-icons">
                        <a href="https://itunes.apple.com/us/app/mybswhealth/id1000856979?mt=8" target="_blank" onClick={() => logUI(`${logPrefix}.iTunes.Clicked`, new Date(), Tools.getURLPath())}>
                            <span className="icon-apple-store" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.baylorscottandwhite.healthsource&hl=en" target="_blank" onClick={() => logUI(`${logPrefix}.GooglePlay.Clicked`, new Date(), Tools.getURLPath())}>
                            <span className="icon-google-store" />
                        </a>
                      </div>
                    : <React.Fragment>
                        {buttonURL
                            ? <a className={buttonClassName} href={buttonURL} onClick={this.downloadMobileApp} target="_blank">
                                {buttonLabel}
                              </a>
                            : <Link to="/download" className={buttonClassName}
                                onClick={() => logUI(`${logPrefix}.DownloadApp.General.Clicked`, new Date(), Tools.getURLPath())}>
                                {buttonLabel}
                              </Link>
                        }
                      </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

DownloadAppBtn.propTypes = propTypes;
DownloadAppBtn.defaultProps = defaultProps;

const mapStateToProps = (state, ownProps) => {
    return {
        ssoBaseUrl: state.session.serverData ? state.session.serverData.ssoBaseURL : ""
    };
};

export default connect(mapStateToProps, null)(DownloadAppBtn);